// extracted by mini-css-extract-plugin
export var container = "panelItem-module--container--1Jryg";
export var banner = "panelItem-module--banner--3XhNy";
export var header = "panelItem-module--header--3ek3-";
export var content = "panelItem-module--content--HD_iH";
export var title = "panelItem-module--title--2SweW";
export var label = "panelItem-module--label--lKZ99";
export var logo = "panelItem-module--logo--326TU";
export var boby = "panelItem-module--boby--2T8ZK";